import { Link, useLocation } from 'react-router-dom';

import useGoBack from '@/hooks/useGoBack';
import useTranslations from '@/i18n/useTranslations';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';

import './index.css';

export default function LimitedEditionsReturnRefundPolicyPage() {
  const t = useTranslations('common.limited_editions_return_and_refund_policy');
  const location = useLocation();
  const fallbackRoute =
    typeof location.state?.fromPath === 'string' &&
    location.state.fromPath.startsWith('/')
      ? location.state.fromPath
      : '/';
  const goBackHandler = useGoBack(fallbackRoute);
  const sections = [
    'reporting_issues',
    'guarantee',
    'initiating_return',
    'shipping_costs',
    'replacements',
    'refunds',
  ];

  return (
    <main className="limited-editions-return-refund-policy__page">
      <header className="limited-editions-return-refund-policy__header">
        <BackArrowIcon
          className="limited-editions-return-refund-policy__back-button"
          onClick={goBackHandler}
        />
        <SuarteName className="limited-editions-return-refund-policy__brand" />
      </header>

      <nav className="limited-editions-return-refund-policy__subnav" aria-label={t('navigation.aria_label')}>
        <a href="#overview" className="limited-editions-return-refund-policy__subnav-link">
          {t('navigation.overview')}
        </a>
        {sections.map((section) => (
          <a
            key={section}
            href={`#${section}`}
            className="limited-editions-return-refund-policy__subnav-link"
          >
            {t(`navigation.${section}`)}
          </a>
        ))}
      </nav>

      <header id="overview" className="limited-editions-return-refund-policy__hero">
        <h1>
          <Heading className="limited-editions-return-refund-policy__title">
            {t('title')}
          </Heading>
        </h1>
        <Text className="limited-editions-return-refund-policy__subtitle" paragraph>
          {t('intro')}
        </Text>
      </header>

      <section className="limited-editions-return-refund-policy__grid">
        {sections.map((section) => (
          <article
            key={section}
            id={section}
            className="limited-editions-return-refund-policy__card"
          >
            <h2>
              <Heading className="limited-editions-return-refund-policy__section-title">
                {t(`${section}.title`)}
              </Heading>
            </h2>
            <Text className="limited-editions-return-refund-policy__body" paragraph>
              {t(`${section}.body`)}
            </Text>
          </article>
        ))}
      </section>

      <aside className="limited-editions-return-refund-policy__note" role="note">
        <span className="limited-editions-return-refund-policy__note-dot" aria-hidden="true" />
        <span>
          {t('footer.before_originals_link')}{' '}
          <Link
            className="limited-editions-return-refund-policy__link"
            to="/return-and-refund-policy"
            state={{ fromPath: '/limited-editions-return-and-refund-policy' }}
          >
            {t('footer.originals_link')}
          </Link>
          .
        </span>
      </aside>
    </main>
  );
}
